import { COLOR } from "@finway-group/shared/lib/consts"
import { Tooltip } from "antd"
import React from "react"

interface LineItemField {
    label: string
    value: string | number
    key: string
}

interface LineItemCardProps {
    index: number
    materialCode: string
    name: string
    fields: Array<LineItemField>
    isActive?: boolean
    isLinked?: boolean
    isDisabled?: boolean
    onClick?: () => void
}

const CARD_HEIGHT = 100
const linkedBackgroundColor = COLOR.finway.green

export const LineItemCard = ({ index, materialCode, name, fields, isActive = false, isLinked = false, isDisabled = false, onClick }: LineItemCardProps) => {
    const getCardStyle = () => {
        if (isLinked) {
            return {
                borderColor: linkedBackgroundColor,
                backgroundColor: `${linkedBackgroundColor}20`,
            }
        }
        return {}
    }

    const getCardClasses = () => {
        let classes = "border rounded-lg p-4 transition-all"

        if (isActive) {
            classes += " border-blue-400 bg-blue-50 shadow-md"
        } else if (isDisabled) {
            classes += " border-gray-200 bg-gray-50 opacity-50"
        } else if (!isLinked) {
            classes += " border-gray-200 hover:border-gray-300"
        }

        classes += isDisabled ? " cursor-not-allowed" : " cursor-pointer"

        return classes
    }
    return (
        <div
            className={getCardClasses()}
            style={{
                ...getCardStyle(),
                height: CARD_HEIGHT,
                maxWidth: "min(calc((98vw - 100px) / 2), 700px)",
            }}
            onClick={onClick && !isDisabled ? onClick : undefined}
        >
            <div className="flex items-center gap-3 mb-2 w-full flex-wrap">
                <span className="bg-gray-150 rounded-full px-10">{String(index + 1).padStart(2, "0")}</span>
                {materialCode ? (
                    <div
                        className={`w-100 font-medium bg-gray-100 rounded-full overflow-x-auto`}
                        style={{
                            scrollbarWidth: "none",
                        }}
                    >
                        <span className="px-8 py-4 inline-block min-w-full text-center" style={{ whiteSpace: "nowrap" }}>
                            {materialCode}
                        </span>
                    </div>
                ) : null}

                <Tooltip title={name}>
                    <div
                        className={`font-medium overflow-x-auto max-w-360`}
                        style={{
                            scrollbarWidth: "none",
                        }}
                    >
                        <span className="px-8 py-4 inline-block text-center" style={{ whiteSpace: "nowrap" }}>
                            {name}
                        </span>
                    </div>
                </Tooltip>
            </div>

            <div className={`grid gap-4 text-sm w-full`} style={{ gridTemplateColumns: `repeat(${fields.length}, 1fr)` }}>
                {fields.map((field) => (
                    <div key={field.key}>
                        <div className="">{field.label}</div>
                        <div className="">{field.value}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}
